// extracted by mini-css-extract-plugin
export default {"control":"Control_control__uF9dz","button":"Control_button__IGd0E"};